import React from 'react';
import CtaButton from 'components/blocks/ctaButton/CtaButton';
import Wysiwyg from 'components/blocks/wysiwyg/Wysiwyg';
import MultiMedia from 'components/base/multiMedia/MultiMedia';
import { TMS_EVENT_TYPES as EventTypes } from 'utils/analytics/EVENT_TYPES';

const MEDIA_WIDTH_MAP = { small: '33vw', medium: '50vw', large: '66vw' };

interface SlideProps {
  options: {
    background: string;
    customCssClass: string;
    imageAlignment: string;
    isReversed: boolean;
    mediaWidth: 'small' | 'medium' | 'large';
    variation: string;
  };
  id: string;
  slide: {
    content: string;
    cta: {
      useCTA: boolean;
      buttonText: string;
      link: string;
      buttonActionType: string;
      trackingLabel?: EventTypes;
    };
    images: {
      url: string;
      alt: string;
      mimeType: string;
      width: string | number;
      height: string | number;
      sizes: {
        height: number;
        width: number;
        url: string;
      };
    };
    subTitle: string;
    title: string;
    videoEmbedId: string;
  };
}

function Slide({ slide, options, id }: SlideProps): React.ReactElement {
  const { images, title, subTitle, content, cta, videoEmbedId } = slide;

  const { mediaWidth } = options;

  const responsiveImageSizes = {
    MOBILE: '600px',
    TABLET: '600px',
    DESKTOP: MEDIA_WIDTH_MAP[mediaWidth],
    DEFAULT: '100vw',
  };

  return (
    <div className="slide" id={id}>
      <div className="slide__inner">
        <div className="slide__media">
          <MultiMedia
            videoEmbedId={videoEmbedId}
            id={`slideMedia_${id}_${videoEmbedId}`}
            images={images}
            responsiveImageSizes={responsiveImageSizes}
          />
          {cta.useCTA && (
            <div className="slide__cta">
              <CtaButton
                buttonText={cta.buttonText}
                link={cta.link}
                buttonActionType={cta.buttonActionType}
                trackingLabel={cta.trackingLabel}
              />
            </div>
          )}
        </div>
        <div className="slide__content">
          {title && (
            <h2 className="slide__title">
              <Wysiwyg content={title} />
            </h2>
          )}
          {subTitle && (
            <div className="slide__subTitle">
              <Wysiwyg content={subTitle} />
            </div>
          )}
          {content && (
            <div className="slide__copy">
              <Wysiwyg content={content} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Slide;
